import { Typography } from '@/components/common';
import clsx from 'clsx';
import * as React from 'react';

interface EmptyStateCaseDetailsProps {
	text: string;
	className?: string;
}

export const EmptyStateCaseDetails: React.FC<EmptyStateCaseDetailsProps> = ({
	text,
	className,
}) => {
	return (
		<div
			className={clsx(
				'flex justify-center items-center w-full h-full rounded-2xl border border-dashed border-opacity-primary bg-grey-2 p-4',
				className
			)}
		>
			<Typography type="regular-16" className="text-opacity-black">
				{text}
			</Typography>
		</div>
	);
};
